// Chỗ nào cần màu đỏ thì bọc trong cặp dấu <...>
const data = {
  id: 1,
  title: 'Choose the suitable definition of the highlighted word in the sentence.',
  subTitle: 'Chọn định nghĩa phù hợp của từ trong câu.',
  question: "Here, take this bag - it's quite light.",
  focusedWords: ['light'],
  answers: [
    { id: 1, answer: 'not weighing a lot', isCorrect: true },
    { id: 2, answer: 'a piece of equipment that produces light, such as a lamp or a bulb.', isCorrect: false },
  ],
};

export default data;
